'use client';

import { useEffect } from 'react';

import { THEME_MODE_KEY } from '../lib/security/themeInitScript';
import { applyTheme, getStoredThemeMode, subscribeSystemThemeChange } from '../lib/theme';

/**
 * 항상 마운트되는 provider에서 호출해 OS 테마 변경을 전역으로 반영합니다.
 * - `SYSTEM` 모드에서만 OS `prefers-color-scheme` 변경을 따라갑니다.
 * - `LIGHT`/`DARK` 명시 선택은 OS 변경으로 덮어쓰지 않습니다.
 * - 다른 탭에서 모드가 바뀌면(`storage` 이벤트) 현재 탭에도 반영합니다.
 */
export const useSystemThemeSync = () => {
  useEffect(() => {
    const unsubscribe = subscribeSystemThemeChange(() => {
      if (getStoredThemeMode() === 'SYSTEM') {
        applyTheme('SYSTEM');
      }
    });

    const handleStorage = (event: StorageEvent) => {
      if (event.key === THEME_MODE_KEY) {
        applyTheme(getStoredThemeMode());
      }
    };
    window.addEventListener('storage', handleStorage);

    return () => {
      unsubscribe();
      window.removeEventListener('storage', handleStorage);
    };
  }, []);
};
